import React from 'react'
import useStyles from './styles'
import { Button } from '@material-ui/core'
import classnames from 'clsx'

const Action = ({ item }) => {
  const classes = useStyles()

  if (item.itemType === 'live') {
    return (
      <Button
        className={classnames(classes.button, classes.disabledButton)}
        variant="contained"
        disabled
      >
        This is a live auction item
      </Button>
    )
  } else {
    return null
  }
}

export default Action



// WEBPACK FOOTER //
// ./src/dialogs/Item/Action/index.jsx